import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ExampleCardSkeletonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}))

export const ExampleCardSkeletonTextContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
})
